import icSmartphone from '../assets/images/devices/ic-smartphone.svg';
import icTablet from '../assets/images/devices/ic-tablet.svg';
import icLaptop from '../assets/images/devices/ic-laptop.svg';
import icIot from '../assets/images/devices/ic-iot.svg';

export const DEVICE_CATEGORIES = [
  { value: 'smartphone', label: 'Smartphone' },
  { value: 'tablet', label: 'Tablet' },
  { value: 'laptop', label: 'Laptop' },
  { value: 'iot', label: 'IoT' },
];

const ICON_BY_CATEGORY = {
  smartphone: icSmartphone,
  tablet: icTablet,
  laptop: icLaptop,
  iot: icIot,
};

const LABEL_BY_CATEGORY = Object.fromEntries(
  DEVICE_CATEGORIES.map((c) => [c.value, c.label]),
);

export const DEVICE_ICON_CLASS = 'device-category-icon';

export function getDeviceIcon(category) {
  if (category && !ICON_BY_CATEGORY[category]) {
    console.warn(`[deviceIcons] Unknown deviceCategory "${category}" — using smartphone fallback`);
  }
  return ICON_BY_CATEGORY[category] || ICON_BY_CATEGORY.smartphone;
}

export function getDeviceCategoryLabel(category) {
  if (category && !LABEL_BY_CATEGORY[category]) {
    console.warn(`[deviceIcons] Unknown deviceCategory "${category}" — using smartphone label`);
  }
  return LABEL_BY_CATEGORY[category] || LABEL_BY_CATEGORY.smartphone;
}
